export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.30-1714.32",
  commitId: "fe23fb3e7037feb490fd5bed127e24c17de50a41",
  commitTime: "2026-09-30T17:14:32.000Z",
});
